module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};



//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-react-next/~/core-js/modules/_an-instance.js
// module id = ./node_modules/gatsby-plugin-react-next/node_modules/core-js/modules/_an-instance.js
// module chunks = 168707334958949